import { render, staticRenderFns } from "./Loader.html?vue&type=template&id=181f9886&scoped=true&"
import script from "./Loader.js?vue&type=script&lang=js&"
export * from "./Loader.js?vue&type=script&lang=js&"
import style0 from "./Loader.scss?vue&type=style&index=0&id=181f9886&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f9886",
  null
  
)

export default component.exports